import { useDraggable } from '@dnd-kit/core'
import {CSS} from '@dnd-kit/utilities';

export const SidebarElement = (props: any) => {
    const {attributes, listeners, setNodeRef, transform} = useDraggable({
        id: props.id,
    });

    const style = {
        // Outputs `translate3d(x, y, 0)`
        transform: CSS.Translate.toString(transform),
      };

    return (
        <div style={{...style, padding: "8px", border: '1px solid black'}} ref={setNodeRef} {...listeners} {...attributes}>
            {props.name}
        </div>
    )
}